module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nmodel.meta = model.meta || {}\nconst title = model.meta.title || model.name || model.nameSEO || storage.__(\"error:unknownPageTitle\");\nmodel.meta.title = title;\n// load different bundles according to loaded route\nconst routeConfig \t\t= ((storage.request || {}).route || {}).config || {}\nconst isOffice \t\t\t= routeConfig.isOffice || false\nconst isCrew \t\t\t= routeConfig.isCrew || false\nconst isCustomers \t\t= routeConfig.isCustomers || false\nconst isContractors\t\t= routeConfig.isContractors || false\nconst isRegistration\t= routeConfig.isRegistration || false\nconst isStatic\t\t\t= routeConfig.isStatic || false\nconst isShippingOrder\t= routeConfig.isShippingOrder || false\nconst isInvoice\t\t\t= routeConfig.isInvoice || false\nconst isOffer\t\t\t= routeConfig.isOffer || false\nconst isCreditNote\t\t= routeConfig.isCreditNote || false\nconst bodyClasses = utils.environment.getBodyClasses(environment)\nif(model.bodyClass)\tbodyClasses.push(model.bodyClass);\nif(isOffice)\t\tbodyClasses.push('isOffice');\nif(isCrew)\t\t\tbodyClasses.push('isCrew');\nif(isCustomers)\t\tbodyClasses.push('isCustomers');\nif(isContractors)\tbodyClasses.push('isContractors');\nif(isRegistration)\tbodyClasses.push('isRegistration');\nif(isStatic)\t\tbodyClasses.push('isStatic');\n// TODO: i would love to use the strict mode via doctype (<!doctype html>), but only if one finds a solution for the:\n//  \t\t.base_form_fields_autoComplete .optionList margin-bottom: 100% during strict mode problem.\n%><html lang=\"<%= model.lang %>\">\n<head>\n<!-- meta tags -->\n<title><%= title %></title>\n<meta name=\"HandheldFriendly\" content=\"True\">\n<meta name=\"MobileOptimized\" content=\"360\"/>\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n<% utils.forEach(model.meta, function(metaContent, metaName){ %>\n<meta name=\"<%= metaName %>\" content=\"<%= metaContent %>\" />\n<% }); %>\n<%- include('meta') %>\n<!-- css sources -->\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app~appContractors~appCrew~appCustomers~appRegistration.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~style.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/style.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% if(isOffice){ %>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% } else if(isCrew){ %>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appCrew.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% } else if(isCustomers){ %>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appCustomers.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% } else if(isContractors){ %>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appContractors.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% } else if(isRegistration || isStatic){ %>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appRegistration.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% } %>\n</head>\n<body class=\"<%- bodyClasses.join(' ') %>\">\n<!-- sections -->\n<div class=\"appContainer\">\n<%- helpers.renderSection('status'); %>\n<%- helpers.renderSection('main'); %>\n<%- helpers.renderSection('login'); %>\n</div>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route \t\t\t\t= \"<%= model.route || '' %>\";\nglobalThis.tree \t\t\t\t= <%- model.tree || 'null' %>;\nglobalThis.globalActionsByScope = <%- model.globalActionsByScope || 'null' %>;\nglobalThis.updateClientStorage \t= <%- model.updateClientStorage || 'null' %>;\nglobalThis.routeParams \t\t\t= <%- model.routeParams || {} %>;\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app~appContractors~appCrew~appCustomers~appRegistration.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% if(isOffice){ %>\n<script type=\"text/javascript\" src=\"/webpack/js/appDocumentPDF.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/app.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% } else if(isCrew){ %>\n<script type=\"text/javascript\" src=\"/webpack/js/appCrew.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% } else if(isCustomers){ %>\n<script type=\"text/javascript\" src=\"/webpack/js/appCustomers.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% } else if(isContractors){ %>\n<script type=\"text/javascript\" src=\"/webpack/js/appContractors.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% } else if(isRegistration || isStatic){ %>\n<script type=\"text/javascript\" src=\"/webpack/js/appRegistration.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% } %>\n</body>\n</html>"
  , __filename = "components/layouts/master/master.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
model.meta = model.meta || {}
const title = model.meta.title || model.name || model.nameSEO || storage.__("error:unknownPageTitle");
model.meta.title = title;
// load different bundles according to loaded route
const routeConfig 		= ((storage.request || {}).route || {}).config || {}
const isOffice 			= routeConfig.isOffice || false
const isCrew 			= routeConfig.isCrew || false
const isCustomers 		= routeConfig.isCustomers || false
const isContractors		= routeConfig.isContractors || false
const isRegistration	= routeConfig.isRegistration || false
const isStatic			= routeConfig.isStatic || false
const isShippingOrder	= routeConfig.isShippingOrder || false
const isInvoice			= routeConfig.isInvoice || false
const isOffer			= routeConfig.isOffer || false
const isCreditNote		= routeConfig.isCreditNote || false
const bodyClasses = utils.environment.getBodyClasses(environment)
if(model.bodyClass)	bodyClasses.push(model.bodyClass);
if(isOffice)		bodyClasses.push('isOffice');
if(isCrew)			bodyClasses.push('isCrew');
if(isCustomers)		bodyClasses.push('isCustomers');
if(isContractors)	bodyClasses.push('isContractors');
if(isRegistration)	bodyClasses.push('isRegistration');
if(isStatic)		bodyClasses.push('isStatic');
// TODO: i would love to use the strict mode via doctype (<!doctype html>), but only if one finds a solution for the:
//  		.base_form_fields_autoComplete .optionList margin-bottom: 100% during strict mode problem.

    ; __line = 27
    ; __append("<html lang=\"")
    ; __append(escapeFn( model.lang ))
    ; __append("\">\n<head>\n<!-- meta tags -->\n<title>")
    ; __line = 30
    ; __append(escapeFn( title ))
    ; __append("</title>\n<meta name=\"HandheldFriendly\" content=\"True\">\n<meta name=\"MobileOptimized\" content=\"360\"/>\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n")
    ; __line = 34
    ;  utils.forEach(model.meta, function(metaContent, metaName){ 
    ; __append("\n<meta name=\"")
    ; __line = 35
    ; __append(escapeFn( metaName ))
    ; __append("\" content=\"")
    ; __append(escapeFn( metaContent ))
    ; __append("\" />\n")
    ; __line = 36
    ;  }); 
    ; __append("\n")
    ; __line = 37
    ; __append( include('meta') )
    ; __append("\n<!-- css sources -->\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app~appContractors~appCrew~appCustomers~appRegistration.css?usTS=")
    ; __line = 39
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~style.css?usTS=")
    ; __line = 40
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/style.css?usTS=")
    ; __line = 41
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 42
    ;  if(isOffice){ 
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css?usTS=")
    ; __line = 43
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 44
    ;  } else if(isCrew){ 
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appCrew.css?usTS=")
    ; __line = 45
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 46
    ;  } else if(isCustomers){ 
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appCustomers.css?usTS=")
    ; __line = 47
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 48
    ;  } else if(isContractors){ 
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appContractors.css?usTS=")
    ; __line = 49
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 50
    ;  } else if(isRegistration || isStatic){ 
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appRegistration.css?usTS=")
    ; __line = 51
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 52
    ;  } 
    ; __append("\n</head>\n<body class=\"")
    ; __line = 54
    ; __append( bodyClasses.join(' ') )
    ; __append("\">\n<!-- sections -->\n<div class=\"appContainer\">\n")
    ; __line = 57
    ; __append( helpers.renderSection('status') )
    ; __append("\n")
    ; __line = 58
    ; __append( helpers.renderSection('main') )
    ; __append("\n")
    ; __line = 59
    ; __append( helpers.renderSection('login') )
    ; __append("\n</div>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route 				= \"")
    ; __line = 63
    ; __append(escapeFn( model.route || '' ))
    ; __append("\";\nglobalThis.tree 				= ")
    ; __line = 64
    ; __append( model.tree || 'null' )
    ; __append(";\nglobalThis.globalActionsByScope = ")
    ; __line = 65
    ; __append( model.globalActionsByScope || 'null' )
    ; __append(";\nglobalThis.updateClientStorage 	= ")
    ; __line = 66
    ; __append( model.updateClientStorage || 'null' )
    ; __append(";\nglobalThis.routeParams 			= ")
    ; __line = 67
    ; __append( model.routeParams || {} )
    ; __append(";\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app~appContractors~appCrew~appCustomers~appRegistration.js?usTS=")
    ; __line = 70
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 71
    ;  if(isOffice){ 
    ; __append("\n<script type=\"text/javascript\" src=\"/webpack/js/appDocumentPDF.js?usTS=")
    ; __line = 72
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/app.js?usTS=")
    ; __line = 73
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 74
    ;  } else if(isCrew){ 
    ; __append("\n<script type=\"text/javascript\" src=\"/webpack/js/appCrew.js?usTS=")
    ; __line = 75
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 76
    ;  } else if(isCustomers){ 
    ; __append("\n<script type=\"text/javascript\" src=\"/webpack/js/appCustomers.js?usTS=")
    ; __line = 77
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 78
    ;  } else if(isContractors){ 
    ; __append("\n<script type=\"text/javascript\" src=\"/webpack/js/appContractors.js?usTS=")
    ; __line = 79
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 80
    ;  } else if(isRegistration || isStatic){ 
    ; __append("\n<script type=\"text/javascript\" src=\"/webpack/js/appRegistration.js?usTS=")
    ; __line = 81
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 82
    ;  } 
    ; __append("\n</body>\n</html>")
    ; __line = 84
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/layouts/master/master.ejs

}